import { LoadingButton } from "@mui/lab";
import {
  Box,
  FormHelperText,
  Grid,
  Link,
  Typography,
  useMediaQuery,
} from "@mui/material";
import whiteLogo from "assets/logos/logo-transparent-dark-bg.png";
import logo from "assets/logos/logo-transparent.png";
import FairPayPic from "assets/splashpage/fair_pay.jpg";
import { AlertContext } from "contexts/Alert";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "schemas/routes";

import { FAIR_PAY_TERMS_AND_CONDITIONS } from "constants/influencer";
import { PAGE_VISITED } from "constants/trackingProps";
import { fetcher } from "utils/api";
import { trackEvent } from "utils/tracking";

import styles from "./styles";

export default function SurveySplashPage() {
  const isMobileScreen = useMediaQuery("(max-width:500px)");
  const navigate = useNavigate();
  const { setErrorAlert } = useContext(AlertContext);
  const [loading, setLoading] = useState<boolean>(false);
  const handleCreateReport = async () => {
    trackEvent("Fair Pay - Run My Free Audit Button Clicked");
    try {
      setLoading(true);
      const { surveyResponse } = await fetcher(
        `/api/organization/fair-pay-survey-responses`,
        "POST",
      );
      navigate(`/${routes.fairpay}/${surveyResponse.surveyUuid}/onboarding`);
    } catch (error) {
      setErrorAlert(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    trackEvent(PAGE_VISITED);
  }, []);

  return (
    <Grid container sx={isMobileScreen ? {} : styles.containerDesktop}>
      {isMobileScreen && (
        <Box component="img" src={FairPayPic} sx={styles.picture} />
      )}
      <Link
        target="_blank"
        href={"https://onbento.com?s=fairpay"}
        onClick={() => {
          trackEvent("Fair Pay - Bento Logo Clicked");
        }}
        sx={{ zIndex: 10 }}
      >
        <Box
          component="img"
          src={isMobileScreen ? logo : whiteLogo}
          sx={styles.logo}
        />
      </Link>

      <Box sx={isMobileScreen ? styles.blackFade : styles.blackFadeDesktop}>
        <Typography
          textAlign="center"
          variant="h2"
          sx={{ color: "yellow.main", fontSize: 40, fontWeight: 600 }}
          gutterBottom
        >
          Are brands paying you fairly?
        </Typography>

        <Typography
          textAlign="center"
          sx={{ color: "white", fontSize: 20, px: 5, mb: 3 }}
        >
          In 60 seconds, see how you compare to others.
        </Typography>

        <Box sx={{ backgroundColor: "white", borderRadius: 4, p: 3 }}>
          <Typography textAlign={"center"} sx={styles.text}>
            Drop your socials & niche
          </Typography>
          <Typography textAlign={"center"} sx={styles.text}>
            Log in with Gmail
          </Typography>
          <Typography textAlign={"center"} sx={styles.text}>
            Get your Fair Pay Report
          </Typography>

          <Grid container justifyContent={"center"} sx={{ my: 2 }}>
            <LoadingButton
              loading={loading}
              variant="contained"
              disableElevation
              sx={styles.button}
              onClick={handleCreateReport}
            >
              Run My Free Audit{" "}
              <Box sx={styles.circle}>
                <Box
                  component="i"
                  className="fa-regular fa-arrow-up-right"
                  sx={{ fontSize: 16 }}
                />
              </Box>
            </LoadingButton>
          </Grid>

          <Typography textAlign="center" sx={{ fontSize: 16, opacity: 0.6 }}>
            Fast, private, under 60 seconds.
            <br />
            Only deal info is used.
          </Typography>

          <FormHelperText sx={{ mt: 1, textAlign: "center" }}>
            By proceeding, you agree to the{" "}
            <Link
              sx={{ color: "primary.main", cursor: "pointer" }}
              href={FAIR_PAY_TERMS_AND_CONDITIONS}
              target="_blank"
              rel="noreferrer"
            >
              Terms & Conditions
            </Link>
          </FormHelperText>
        </Box>
      </Box>
    </Grid>
  );
}
